import { Button, Divider, Modal, Paper, Typography, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../app/hooks";
import { getFanList } from "../../app/reducer/fan.reducer";
import { selectFan } from "../../app/reducer/project.reducer";
import SearchList from "../general/SearchList";

interface PopUpProps{
    open: boolean;
    handleClose: Function;
    setIndex: Function;
}
export default function SelectFanPopUp({open,handleClose,setIndex}:PopUpProps) {

    const [fanListState, setFanListState] = React.useState<any[]>([]);
    
    const fanList = useAppSelector(getFanList);
    const dispatch = useDispatch();

    const selectFanCTA = async (fan:any) => {
        await dispatch(selectFan(fan));
        handleClose();
    }

    useEffect(() => {
        let tempFanList = [];
        if(fanList){
            tempFanList = fanList.slice().sort((a:any,b:any)=>{
                if(a && b && a.designPoint && b.designPoint)
                return b.designPoint.expectedEfficiency - a.designPoint.expectedEfficiency
                else 
                return a-b
            });
            setFanListState(tempFanList);
        }
    }, [fanList])

    return (
        <Modal
            open={open}
            onClose={e => { return; }}
        >
            <Paper className="form-wrapper popup-wrapper" style={{ position: "relative" }}>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    style={{ position: "absolute", right: 8, top: 8, zIndex: 1 }}
                >
                    <CloseIcon />
                </IconButton>
                <Typography variant="h4" gutterBottom>
                    <b>{(fanListState!==undefined && fanListState.length > 0) ?"Select Fan:":"No Fan Found within selected parameters."}</b>
                </Typography>
                <Divider/>
                {(fanListState!==undefined && fanListState.length > 0) ?
                <SearchList btnVariant="primary" searchLabel="Select Fan"
                    colHeaders={["Fan Model","Expected Efficiency","Expected Angle",""]}
                    rowKeys={["fanModelID","designPoint.expectedEfficiency","designPoint.expectedAngle"]}
                    data={fanListState} cta={selectFanCTA}
                />
                :
                <div  style={{minHeight:'300px', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={e=>handleClose()}
                    >
                        Close
                    </Button>
                </div>}
            </Paper>
        </Modal>
    );
}
